import { render, staticRenderFns } from "./reqBoardList.vue?vue&type=template&id=6e308793&scoped=true"
import script from "./reqBoardList.vue?vue&type=script&lang=js"
export * from "./reqBoardList.vue?vue&type=script&lang=js"
import style0 from "./reqBoardList.vue?vue&type=style&index=0&id=6e308793&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e308793",
  null
  
)

export default component.exports